import * as crypto from 'crypto'
import { v1 as uuidv1 } from 'uuid'

import { getDocumentObject } from '../common/utils/commonUtils'

/** Launch Darkly device uuid key in local storage */
export const LAUNCH_DARKLY_DEVICE_UUID_LOCAL_STORAGE_KEY = 'ld:device'

const hashUUID = (v1: string): string => {
  // crypto.createHash is available in the browser via crypto-browserify polyfill, but not in Cypress which lacks that polyfill
  if (typeof crypto.createHash === 'function') {
    return crypto.createHash('sha256').update(v1).digest('hex')
  }
  return globalThis.crypto.randomUUID()
}

/**
 * Get launch darkly user device uuid stored in local storage
 */
export const launchDarklyUserDeviceUUID = (() => {
  let deviceUUID = null
  if (getDocumentObject() && typeof localStorage !== undefined) {
    const currentDeviceUUID = localStorage.getItem(LAUNCH_DARKLY_DEVICE_UUID_LOCAL_STORAGE_KEY)
    if (currentDeviceUUID) {
      return currentDeviceUUID
    } else {
      const v1 = uuidv1()
      if (v1) {
        deviceUUID = hashUUID(v1)
        localStorage.setItem(LAUNCH_DARKLY_DEVICE_UUID_LOCAL_STORAGE_KEY, deviceUUID)
      } else {
        console.warn('Failed to set LaunchDarkly device uuid - Could not get v1 from uuid')
      }
    }
  }
  return deviceUUID
})()
